import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Flower2, Sparkles, Flame, Leaf, Sun } from "lucide-react";
import { API } from "../lib/api";
import { useAuth } from "../context/AuthContext";

const VIBES = [
  ["soft", Flower2, "Soft", "Soft glam, pastels & easy everyday."],
  ["glam", Sparkles, "Glam", "Bold lips, shimmer & statement finds."],
  ["bold", Flame, "Bold", "Bright colour and fearless style."],
  ["minimal", Leaf, "Minimal", "Clean, classic, effortless."],
  ["desi", Sun, "Desi", "Ethnic, festive & jewellery love."],
];

const todayKey = () => new Date().toISOString().slice(0, 10);

export default function DailyVibe() {
  const { user } = useAuth();
  const [picked, setPicked] = useState("");

  useEffect(() => {
    try {
      const raw = JSON.parse(localStorage.getItem("svk_vibe") || "{}");
      if (raw.date === todayKey()) setPicked(raw.value || "");
    } catch { /* ignore */ }
  }, []);

  const choose = (key) => {
    setPicked(key);
    localStorage.setItem("svk_vibe", JSON.stringify({ date: todayKey(), value: key }));
    if (user) API.put("/sakhi/me", { mood: key }).catch(() => {});
  };

  const active = VIBES.find((v) => v[0] === picked);

  return (
    <section className="py-12 sm:py-16 bg-white" data-testid="daily-vibe">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <p className="text-xs font-semibold tracking-[0.3em] uppercase text-[#6A1B29]">Daily Vibe</p>
        <h2 className="font-display text-3xl sm:text-4xl font-semibold text-stone-900 mt-2">What's Your Vibe Today?</h2>
        <p className="text-stone-500 mt-2">{picked ? "Love it. Come back tomorrow for a fresh vibe." : "Pick a mood — we'll help you find your look."}</p>
        <div className="flex flex-wrap justify-center gap-3 sm:gap-4 mt-7" data-testid="vibe-options">
          {VIBES.map(([key, Icon, label]) => {
            const sel = picked === key;
            return (
              <button key={key} onClick={() => choose(key)} data-testid={`vibe-${key}`}
                className={`flex flex-col items-center gap-1.5 w-[86px] sm:w-24 py-4 rounded-2xl border transition-all ${sel ? "border-[#6A1B29] bg-[#FFF0F4] scale-105 shadow-sm" : "border-stone-200 bg-white hover:border-[#6A1B29] hover:-translate-y-0.5"}`}>
                <Icon className={`w-7 h-7 ${sel ? "text-[#6A1B29]" : "text-stone-500"}`} />
                <span className={`text-sm font-semibold ${sel ? "text-[#6A1B29]" : "text-stone-700"}`}>{label}</span>
              </button>
            );
          })}
        </div>
        {active && (
          <div className="mt-6 inline-flex flex-col sm:flex-row items-center gap-3 bg-[#FAF6F1] border border-stone-200 rounded-2xl px-5 py-4" data-testid="vibe-result">
            <p className="text-sm text-stone-700"><span className="font-semibold text-stone-900">{active[2]} vibe</span> — {active[3]}</p>
            <Link to={`/discover?vibe=${active[0]}`} className="text-sm font-semibold text-white bg-[#6A1B29] hover:bg-[#501325] px-5 py-2 rounded-full whitespace-nowrap" data-testid="vibe-discover-cta">Find your look →</Link>
          </div>
        )}
      </div>
    </section>
  );
}
